// routes
// eslint-disable-next-line import/no-unresolved
import { MODULE_ROLE } from 'src/constants/Dashboard';
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import Label from '../../components/Label';
import SvgIconStyle from '../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

export const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  file: getIcon('ic_dropbox'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_analystics')
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    // subheader: 'general',
    items: [
      { title: 'Dashboard', name: 'dashboard', path: PATH_DASHBOARD.general.dashboard, icon: ICONS.dashboard },
      // { title: 'Score', path: PATH_DASHBOARD.general.score, icon: ICONS.ecommerce },
      // { title: 'Staff', path: PATH_DASHBOARD.general.Staff, icon: ICONS.analytics },
      {
        title: 'MasterData',
        path: PATH_DASHBOARD.general.master_data,
        // icon: ICONS.blog,
        icon: ICONS.blog,
        children: [
          { title: 'Client', name: MODULE_ROLE.createclient, path: PATH_DASHBOARD.general.client },
          { title: 'Vendors', name: MODULE_ROLE.createvendor, path: PATH_DASHBOARD.general.vendor },
          { title: 'Projects', name: MODULE_ROLE.project, path: PATH_DASHBOARD.general.project },
          { title: 'Headers', name: MODULE_ROLE.headers, path: PATH_DASHBOARD.general.header },
          { title: 'Column Map', name: 'columnmap', path: PATH_DASHBOARD.general.columnmap },
          {
            title: 'Filtering Rule',
            name: MODULE_ROLE.exclusionrule,
            path: PATH_DASHBOARD.general.exclusion_rule
          },
          {
            title: 'Campaign Rule',
            name: MODULE_ROLE.campaignrule,
            path: PATH_DASHBOARD.general.campaign_rule
          },
          { title: 'Project Config', path: PATH_DASHBOARD.general.project_config }

          // { title: 'new post', path: PATH_DASHBOARD.blog.newPost }
        ]
      },
      {
        title: 'File Manager',
        path: PATH_DASHBOARD.general.file_manager,
        icon: ICONS.file,
        children: [
          {
            title: 'File Management',
            name: MODULE_ROLE.masterfile,
            path: PATH_DASHBOARD.general.master_file
          },
          {
            title: 'File Type',
            name: MODULE_ROLE.categoryname,
            path: PATH_DASHBOARD.general.file_category
          }
          // { title: 'Increment File', path: PATH_DASHBOARD.general.increment_file }
          // { title: 'Campaign File', path: PATH_DASHBOARD.general.campaign_file }
        ]
      },
      {
        title: 'Collection Data',
        path: PATH_DASHBOARD.general.collection_data,
        icon: ICONS.kanban,
        // icon: ICONS.user,
        children: [
          {
            title: 'Collection',
            name: MODULE_ROLE.collectiondatafile,
            path: PATH_DASHBOARD.general.collection
          },
          { title: 'Scoring Model', name: 'scoringmodel', path: PATH_DASHBOARD.general.scoring }
          // { title: 'Segmentation', path: PATH_DASHBOARD.general.segmentation }
          // { title: 'Client List', path: PATH_DASHBOARD.blog.postById }
          // { title: 'new post', path: PATH_DASHBOARD.blog.newPost }
        ]
      },
      { title: 'Customer Search', path: PATH_DASHBOARD.general.customer_search, icon: ICONS.calendar },
      {
        title: 'Reports',
        path: PATH_DASHBOARD.general.reports,
        icon: ICONS.analytics
        // // icon: ICONS.user,
        // children: [
        //   { title: 'Collection', path: PATH_DASHBOARD.general.collection_data },
        //   { title: 'Segmentation', path: PATH_DASHBOARD.general.segmentation }
        //   // { title: 'Client List', path: PATH_DASHBOARD.blog.postById }
        // { title: 'new post', path: PATH_DASHBOARD.blog.newPost }
        // ]
      },
      {
        title: 'User Management',
        path: PATH_DASHBOARD.general.user_management,
        icon: ICONS.user,
        // icon: ICONS.user,
        children: [
          { title: 'User Role', name: MODULE_ROLE.userrole, path: PATH_DASHBOARD.general.user_role },
          { title: 'Users', name: MODULE_ROLE.user, path: PATH_DASHBOARD.general.users }
          // { title: 'Client List', path: PATH_DASHBOARD.blog.postById }
          // { title: 'new post', path: PATH_DASHBOARD.blog.newPost }
        ]
      }
      // {
      //   title: 'Omni Channel',
      //   path: PATH_DASHBOARD.general.omni_channel,
      //   icon: ICONS.mail
      //   // icon: ICONS.user,
      // },
      // {
      //   title: 'QA',
      //   path: PATH_DASHBOARD.general.qa,
      //   icon: ICONS.ecommerce
      //   // icon: ICONS.user,
      // }
    ]
  }

  // MANAGEMENT
  // ----------------------------------------------------------------------
  // {
  //   items: [
  //     // MANAGEMENT : USER
  //     {
  //       title: 'user',
  //       path: PATH_DASHBOARD.user.root,
  //       icon: ICONS.user,
  //       children: [
  //         { title: 'profile', path: PATH_DASHBOARD.user.profile },
  //         { title: 'cards', path: PATH_DASHBOARD.user.cards },
  //         { title: 'list', path: PATH_DASHBOARD.user.list },
  //         { title: 'create', path: PATH_DASHBOARD.user.newUser },
  //         { title: 'edit', path: PATH_DASHBOARD.user.editById },
  //         { title: 'account', path: PATH_DASHBOARD.user.account }
  //       ]
  //     },

  //     // MANAGEMENT : E-COMMERCE
  //     {
  //       title: 'e-commerce',
  //       path: PATH_DASHBOARD.eCommerce.root,
  //       icon: ICONS.cart,
  //       children: [
  //         { title: 'shop', path: PATH_DASHBOARD.eCommerce.shop },
  //         { title: 'product', path: PATH_DASHBOARD.eCommerce.productById },
  //         { title: 'list', path: PATH_DASHBOARD.eCommerce.list },
  //         { title: 'create', path: PATH_DASHBOARD.eCommerce.newProduct },
  //         { title: 'edit', path: PATH_DASHBOARD.eCommerce.editById },
  //         { title: 'checkout', path: PATH_DASHBOARD.eCommerce.checkout },
  //         { title: 'invoice', path: PATH_DASHBOARD.eCommerce.invoice }
  //       ]
  //     }
  //   ]
  // },

  // APP
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'app',
  //   items: [
  //     {
  //       title: 'mail',
  //       path: PATH_DASHBOARD.mail.root,
  //       icon: ICONS.mail,
  //       info: <Label color="error">2</Label>
  //     },
  //     { title: 'chat', path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },
  //     { title: 'calendar', path: PATH_DASHBOARD.calendar, icon: ICONS.calendar },
  //     {
  //       title: 'kanban',
  //       path: PATH_DASHBOARD.kanban,
  //       icon: ICONS.kanban
  //     }
  //   ]
  // }
];

export default sidebarConfig;
